import type { ServiceFee } from "./zod/serviceFee";
// import { IS_PROD } from "./utils/getEnvVariable";

export const DEFAULT_PLATFORM_SERVICE_FEE: ServiceFee = {
    ratePerOrder: 1,
    // ratePerOrder: IS_PROD ? 0 : 1,
    feePerOrder: 0,
};
